'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var THREAD_ID = exports.THREAD_ID = ['threadId'];
var CHANNEL = exports.CHANNEL = ['channel'];
var MESSAGE = exports.MESSAGE = ['message'];